/** Pavilion compact shell — matches Figma / transparent native window cutouts */
/** Inset from work-area / parent rect right-bottom; keep in sync with host-electron PAVILION_WORK_AREA_MARGIN. */
export const PAVILION_WORK_AREA_MARGIN_PX = 12;

export const PAVILION_SHELL_RADIUS = 'rounded-[5px]';
export const PAVILION_SHELL_BORDER = 'border-[3px] border-[#FBBF24]';
export const PAVILION_SHELL_GRADIENT = 'bg-gradient-to-b from-[#020617] to-[#1E1B4B]';
